import { generateUtilityClass, generateUtilityClasses } from "@mui/material";
const truncateListName = "TidalTruncateList";
function getTruncateListUtilityClass(slot) {
  return generateUtilityClass(truncateListName, slot);
}
const truncateListClasses = generateUtilityClasses(truncateListName, [
  "root",
  "content"
]);
export {
  getTruncateListUtilityClass,
  truncateListClasses,
  truncateListName
};
//# sourceMappingURL=classes.js.map
